/**
 * Calculate expected return time based on destination type
 * 30s to reach destination + variable time at destination based on type + 30s to return
 */
export const calculateExpectedReturnTime = (startTime: number, destinationType: string): number => {
  // Always 3 minutes (180 seconds)

  //todo - implement destinationType lookup
  console.log(`Calculating expected return time for destination type: ${destinationType}`);
  return startTime + 3 * 60 * 1000;
};

/**
 * Format time remaining in a human-readable format
 */
export const formatTimeRemaining = (timeInMs: number): string => {
  if (timeInMs <= 0) return 'Overdue';
  
  const seconds = Math.floor(timeInMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  
  if (minutes === 0) {
    return `${remainingSeconds}s`;
  }
  
  return `${minutes}m ${remainingSeconds}s`;
};

/**
 * Get status based on expected return time
 */
export const getStatus = (expectedReturnTime: number): 'on-time' | 'warning' | 'overdue' => {
  const now = Date.now();
  const timeRemaining = expectedReturnTime - now;
  
  if (timeRemaining <= 0) {
    return 'overdue';
  }
  
  if (timeRemaining < 30000) { // Less than 30 seconds
    return 'warning';
  }
  
  return 'on-time';
};